// Customizable Area Start
import React from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import { Formik, Form } from "formik";
import ForgotPasswordController, {
  Props,
  configJSON,
  validationSchema,
} from "./ForgotPasswordController.web";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import AppFooter from "../../../components/src/AppFooter.web";
import CustomPageLayout from "../../../components/src/CustomPageLayout.web";
import CustomTextField from "../../../components/src/CustomTextField.web";
import CustomButton from "../../../components/src/CustomButton.web";
import CustomInfoIcon from "../../../components/src/CustomInfoIcon.web";
import CustomInfoDialog from "../../../components/src/CustomInfoDialog.web";

const MainHeading = styled(Typography)({
  color: "#0F172A",
  fontSize: "1.75rem",
  fontWeight: 600,
  letterSpacing: "-0.12px",
  margin: "20px 0px 15px",
});

const SubHeading = styled(Typography)({
  color: "#64748B",
  fontSize: "1rem",
  fontWeight: 400,
  marginBottom: "15px",
});

const MainBtn = styled(CustomButton)({
  minHeight: "56px",
  marginTop: "40px",
});

const SuccessSentWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "10px",
  paddingTop: "15px",
});

const CustomTextButton = styled(Button)({
  color: "#652784",
  fontSize: "1rem",
  fontWeight: 500,
  textTransform: "none",
});

const ErrorText = styled(Typography)({
  color: "#E11B23",
  fontSize: "0.75rem",
  fontWeight: 400,
  marginTop: "3px",
  marginLeft: "14px",
});
// Customizable Area End

export default class ForgotPassword extends ForgotPasswordController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }
  // Customizable Area Start
  render() {
    const { navigation } = this.props;
    const {
      isLoading,
      apiError,
      successSentMailEmail,
      isForgotPassEmailSent,
      isInfoDialog,
      infoType,
      infoMessage,
    } = this.state;
    return (
      <>
        <FullPageLoader isLoading={isLoading} />
        <NavigationMenu navigation={navigation} id={""} />

        <CustomPageLayout>
          {isForgotPassEmailSent ? (
            <SuccessSentWrapper>
              <CustomInfoIcon data-test-id="success-icon" infoType="success" />
              <MainHeading>{configJSON.forgotPasswordText}</MainHeading>
              <SubHeading align="center">
                {`${configJSON.successForgotMailSentMessage1}${successSentMailEmail}${configJSON.successForgotMailSentMessage2}`}
              </SubHeading>
              <MainBtn
                fullWidth
                sx={{ marginTop: 2 }}
                customVariant="filled"
                onClick={this.handleReSendForgotEmail}
              >
                {configJSON.resendForgotEmailText}
              </MainBtn>
              <CustomTextButton
                data-test-id="contact-us"
                onClick={this.handleContactUsRedirect}
              >
                {configJSON.contactUsText}
              </CustomTextButton>
            </SuccessSentWrapper>
          ) : (
            <Formik
              validateOnChange
              data-test-id="formik"
              initialValues={{ email: "" }}
              validationSchema={validationSchema}
              onSubmit={this.handleForgotPasswordEmailSend}
            >
              {({ errors, touched, values, handleChange, handleSubmit }) => (
                <Form
                  onSubmit={(event) => {
                    event.preventDefault();
                    handleSubmit();
                  }}
                >
                  <MainHeading data-test-id="main-heading">
                    {configJSON.forgotPasswordText}
                  </MainHeading>
                  <SubHeading>
                    {configJSON.enterYourEmailAddressText}
                  </SubHeading>
                  <CustomTextField
                    fullWidth
                    name="email"
                    variant="outlined"
                    label="Email Address"
                    placeholder="Enter your email address"
                    touched={touched.email}
                    error={errors.email}
                    value={values.email}
                    handleChange={handleChange}
                  />
                  {apiError && (
                    <ErrorText data-test-id="error-message">
                      {apiError}
                    </ErrorText>
                  )}
                  <MainBtn
                    fullWidth
                    type="submit"
                    disabled={isLoading || !values.email.trim()}
                    customVariant="filled"
                  >
                    {configJSON.sendForgotPassLinkText}
                  </MainBtn>
                </Form>
              )}
            </Formik>
          )}
        </CustomPageLayout>
        <CustomInfoDialog
          data-test-id="info-dialog"
          isOpen={isInfoDialog}
          infoType={infoType}
          title={infoMessage}
          handleClose={this.closeInfoDialog}
        />
        <AppFooter navigation={navigation} />
      </>
    );
  }
  // Customizable Area End
}
